export default __webpack_public_path__ + "static/media/gallery-fudge_00.9829daab.jpg";